import getNative from './_getNative.js';
import root from './_root.js';

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

export default Set;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_Set.js
// module id = 455
// module chunks = 30 31 32 33 34